var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinigames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4345",
    "data-name": "Rectangle 4345",
    width: 24,
    height: 24,
    transform: "translate(-2.465 -4)",
    fill: "#97a1c2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908",
    transform: "translate(-98 -752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    transform: "translate(249.465 684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4707",
    "data-name": "Group 4707",
    transform: "translate(-149 72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740",
    transform: "translate(-0.466 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M16.745,14.159l-3.82-1.7a7.092,7.092,0,0,0-5.776,0l-3.82,1.7a2.364,2.364,0,0,1-3.3-2.489L1.381,2.036A2.365,2.365,0,0,1,4.373.092L8.737,1.339a4.718,4.718,0,0,0,2.6,0L15.7.092a2.365,2.365,0,0,1,2.991,1.944l1.357,9.634a2.364,2.364,0,0,1-3.3,2.489",
    transform: "translate(0 0)",
    fill: "rgba(151,161,194,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M15.437,5.52a2.242,2.242,0,1,1-2.242-2.242A2.242,2.242,0,0,1,15.437,5.52",
    transform: "translate(1.326 0.397)",
    fill: "#97a1c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M23304.686-642.513v-.679h-.562a1.124,1.124,0,0,1-1.123-1.123,1.123,1.123,0,0,1,1.123-1.117h.563v-.445A1.123,1.123,0,0,1,23305.8-647a1.124,1.124,0,0,1,1.123,1.123v.445h.568a1.123,1.123,0,0,1,1.123,1.117,1.124,1.124,0,0,1-1.123,1.123h-.568v.679a1.123,1.123,0,0,1-1.123,1.117A1.121,1.121,0,0,1,23304.686-642.513Z",
    transform: "translate(-23300.256 650.115)",
    fill: "#97a1c2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinigames);
export default __webpack_public_path__ + "static/media/minigames.068624fd85f8e16c8d195c5df6927d3c.svg";
export { ForwardRef as ReactComponent };